import { selectPlaceData, selectPlaceFilters } from 'containers/MapDetails/placeSlice'
import useTranslation from 'hooks/useTranslation'
import { WarehouseGroup } from './Summary'
import { useReduxSelector } from 'store'
import ListItem from './ListItem'
import React from 'react'

const List: React.FC = () => {
  const filters = useReduxSelector(selectPlaceFilters)
  const place = useReduxSelector(selectPlaceData)

  const hash = filters?.attributes?.hash
  const warehouseTypeId = filters?.attributes?.warehouseTypeId
  const sizeGroups = warehouseTypeId && place?.warehouses?.[warehouseTypeId]
    ? place?.warehouses?.[warehouseTypeId]
    : undefined

  const { t } = useTranslation('placeMap')

  return (
    <div className='placeMap__list'>
      {sizeGroups
        ? hash && sizeGroups[hash]
          ? <ListItem
            hash={hash}
            isSelected
            {...sizeGroups[hash]}
          />
          : Object.entries(sizeGroups as WarehouseGroup).map(([hash, group]) => <ListItem
            key={hash}
            hash={hash}
            {...group}
          />)
        : <p>{t('chooseYourSize')}</p>}
    </div>
  )
}

export default List